<div class="verification-container py-5 px-3 px-md-4 mb-5 mb-md-0">
  <div class="max-width-wrapper mx-auto">
    
    <header class="hero-banner text-white p-4 p-md-5 rounded-4 mb-4 d-flex flex-column justify-content-between position-relative overflow-hidden">
      <div>
        <div class="badge-secure d-inline-flex align-items-center gap-2 mb-3 px-3 py-2 rounded-pill">
          <i class="bi bi-shield-shaded"></i>Secure Verification Process
        </div>
        <h1 class="fw-bold mb-3 display-6 font-inter-bold">Verify Your Trading Partner</h1>
        <p class="hero-subtitle mb-0 col-12 col-lg-8">
          Complete our simple 3-step verification process to verify your buyer or seller. This ensures secure and trustworthy transactions for all parties involved.
        </p>
      </div>
      <div class="mt-4 mt-md-5">
        <button class="btn btn-outline-light action-btn-hero d-inline-flex align-items-center gap-2 px-4 py-2.5 fw-semibold" (click)="startVerification()">
          <i class="bi bi-arrow-right"></i> Start Verification 
        </button>
      </div>
    </header>

    <main class="content-card bg-white rounded-4 border border-1 p-4 p-md-5 shadow-sm">
      
      <section class="mb-5">
        <h2 class="h4 fw-bold  mb-1 verification-process">Verification Process</h2>
        <p class="text-sub small mb-4">Follow these simple steps to verify your trading partner and initiate payment</p>
        
        <div class="position-relative timeline-container">
          <div class="timeline-line position-absolute start-0 top-0 h-100"></div>

          <div class="d-flex gap-3 gap-md-4 mb-4 position-relative align-items-start timeline-item">
            <div class="step-number d-flex align-items-center justify-content-center flex-shrink-0 fw-bold rounded-circle text-white">1</div>
            <div class="step-card step-card-blue p-4 rounded-4 w-100 border border-1">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <h3 class="h6 fw-bold mb-0 step-card-blue-header">Partner's Company Information</h3>
                <span class="badge badge-required border px-2 py-1 small fw-normal rounded-pill">Required</span>
              </div>
              <p class="text-sub small mb-3">Provide the company details of the buyer or seller you wish to verify, including registered name, address, and country of operation.</p>
              <div class="row g-2">
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> Company Name</div>
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> Registered Address</div>
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> Country Selection</div>
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> Website (Optional)</div>
              </div>
            </div>
          </div>

          <div class="d-flex gap-3 gap-md-4 mb-4 position-relative align-items-start timeline-item">
            <div class="step-number d-flex align-items-center justify-content-center flex-shrink-0 fw-bold rounded-circle text-white">2</div>
            <div class="step-card step-card-pink p-4 rounded-4 w-100 border border-1">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <h3 class="h6 fw-bold mb-0 text-dark">Contact Details</h3>
                <span class="badge badge-required  text-muted border px-2 py-1 small fw-normal rounded-pill">Required</span>
              </div>
              <p class="text-muted small mb-3">Share the primary contact person's information for the company being verified. This enables us to reach out for verification purposes.</p>
              <div class="row g-2">
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> Contact Person Name</div>
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> Email Address</div>
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> Phone Number</div>
              </div>
            </div>
          </div>

          <div class="d-flex gap-3 gap-md-4 mb-5 position-relative align-items-start timeline-item">
            <div class="step-number d-flex align-items-center justify-content-center flex-shrink-0 fw-bold rounded-circle text-white">3</div>
            <div class="step-card step-card-green p-4 rounded-4 w-100 border border-1">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <h3 class="h6 fw-bold mb-0 text-dark">Document Upload & Payment</h3>
                <span class="badge badge-required text-muted border px-2 py-1 small fw-normal rounded-pill">Required</span>
              </div>
              <p class="text-muted small mb-3">Upload the company registration certificate or incorporation documents, then proceed with the verification fee payment to complete the process.</p>
              <div class="row g-2">
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> Registration Certificate</div>
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> PDF, JPG, PNG Format</div>
                <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> Max 10MB File size</div>
                <!-- <div class="col-md-6 d-flex align-items-center gap-2 text-dark small"><i class="bi bi-check-circle-fill text-color"></i> $85 Payment Processing</div> -->
              </div>
            </div>
          </div>
        </div>
      </section>

      

    </main>
    <section class="row g-3 mb-4 pt-4">
        <div class="col-md-6">
          <div class="metric-box bg-white p-3 rounded-4 border border-1 d-flex align-items-center gap-3 h-100">
            <div class="metric-icon metric-icon-blue rounded-3 d-flex align-items-center justify-content-center">
              <i class="bi bi-clock-fill"></i>
            </div>
            <div>
              <div class="text-dark fw-bold small">Estimated Time</div>
              <div class="text-muted x-small">Complete the entire process in approximately</div>
              <div class="metric-value text-indigo fw-bold mt-1">5-10 minutes</div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <div class="metric-box bg-white p-3 rounded-4 border border-1 d-flex align-items-center gap-3 h-100">
            <div class="metric-icon metric-icon-orange rounded-3 d-flex align-items-center justify-content-center">
              <i class="bi bi-credit-card-fill"></i>
            </div>
            <div>
              <div class="text-dark fw-bold small">Verification Fee</div>
              <div class="text-muted x-small">One-time payment per verification</div>
              <div class="metric-value text-orange fw-bold mt-1">$85 USD</div>
            </div>
          </div>
        </div> -->
        <div class="col-md-6">
          <div class="metric-box bg-white p-3 rounded-4 border border-1 d-flex align-items-center gap-3 h-100">
            <div class="metric-icon metric-icon-green rounded-3 d-flex align-items-center justify-content-center">
              <i class="bi bi-person-check-fill"></i>
            </div>
            <div>
              <div class="text-dark fw-bold small">Verification Review</div>
              <div class="text-muted x-small">Our team will review your submission within</div>
              <div class="metric-value text-emerald fw-bold mt-1">24-48 hours</div>
            </div>
          </div>
        </div>
      </section>

    <!-- <section class="payment-details-card p-4 rounded-4 border border-1 mb-4">
        <div class="row g-4">
    
            <h4 class="payment-details-header fw-bold  mb-3 d-flex align-items-center gap-2">
                <img src="/icons/payment-details-icon.svg" /> Payment Details
            </h4>
            <div class="row px-md-5 ">
                <div class="col-lg-6 py-2 py-md-0 ">
                    <div class="text-dark small fw-semibold mb-2">Accepted Payment Methods:</div>
                    <div class="d-flex flex-wrap gap-2">
                        <span
                            class="payment-badge border px-3 py-2 rounded-3 d-inline-flex align-items-center gap-1 bg-white small text-secondary fw-semibold">
                           <img src="/icons/visa-icon.svg" alt="Visa" width="24" height="16" class="me-1" /> Visa</span>
                        <span
                            class="payment-badge border px-3 py-2 rounded-2 d-inline-flex align-items-center gap-1 bg-white small text-secondary fw-semibold">
                                  <img src="/icons/mastercard-icon.svg" alt="Visa" width="24" height="16" class="me-1" /> Mastercard</span>
                        <span
                            class="payment-badge border px-3 py-2rounded-2 d-inline-flex align-items-center gap-1 bg-white small text-secondary fw-semibold"> 
                             <img src="/icons/amex-icon.svg" alt="Visa" width="24" height="16" class="me-1" />Amex</span>
                        <span
                            class="payment-badge border px-3 py-2 rounded-2 d-inline-flex align-items-center gap-1 bg-white small text-secondary fw-semibold">
                              <img src="/icons/paypal-icon.svg" alt="Visa" width="24" height="16" class="me-1" /> PayPal</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="text-dark small fw-semibold mb-2">What You Get:</div>
                    <ul class="list-unstyled d-flex flex-column gap-2 mb-0">
                        <li class="d-flex align-items-start gap-2 small text-secondary"><i
                                class="bi bi-check2 text-check mt-0.5"></i> Comprehensive company background check</li>
                        <li class="d-flex align-items-start gap-2 small text-secondary"><i
                                class="bi bi-check2 text-check mt-0.5"></i> Document authenticity verification</li>
                        <li class="d-flex align-items-start gap-2 small text-secondary"><i
                                class="bi bi-check2 text-check mt-0.5"></i> Detailed verification report</li>
                        <li class="d-flex align-items-start gap-2 small text-secondary"><i
                                class="bi bi-check2 text-check mt-0.5"></i> Trust badge for verified partners</li>
                    </ul>
                </div>
            </div>
        </div>
    </section> -->

      <section class="info-alert p-4 rounded-4 border mb-5">
        <h4 class="h6 fw-bold text-amber-dark mb-3 d-flex align-items-center gap-2">
          <i class="bi bi-info-circle-fill important-info"></i> Important Information
        </h4>
        <ul class="list-unstyled d-flex flex-column gap-2 mb-0 px-md-4 ">
          <li class="d-flex align-items-start gap-2 x-small text-amber"><i class="bi bi-chevron-right mt-1 font-scale-sm text-important-info"></i> The verification fee is non-refundable once the verification process begins</li>
          <li class="d-flex align-items-start gap-2 x-small text-amber"><i class="bi bi-chevron-right mt-1 font-scale-sm text-important-info"></i> Both buyers and sellers can request verification of their trading partners</li>
          <li class="d-flex align-items-start gap-2 x-small text-amber"><i class="bi bi-chevron-right mt-1 font-scale-sm text-important-info"></i> All fields marked with an asterisk (*) are mandatory</li>
          <li class="d-flex align-items-start gap-2 x-small text-amber"><i class="bi bi-chevron-right mt-1 font-scale-sm text-important-info"></i> Ensure all information matches official company registration documents</li>
          <li class="d-flex align-items-start gap-2 x-small text-amber"><i class="bi bi-chevron-right mt-1 font-scale-sm text-important-info"></i> Documents must be clear, legible, and in PDF, JPG, or PNG format</li>
          <li class="d-flex align-items-start gap-2 x-small text-amber"><i class="bi bi-chevron-right mt-1 font-scale-sm text-important-info"></i> You will receive an email notification once verification is complete</li>
        </ul>
      </section>

      <footer class="text-center content-card bg-white rounded-4 border border-1 p-4 p-md-5 shadow-sm">
        <h3 class="h5 fw-bold text-dark mb-2">Ready to Verify Your Trading Partner?</h3>
        <p class="text-muted small mb-4">Begin the verification process now and ensure secure, trustworthy transactions</p>
        <div class="d-flex flex-wrap justify-content-center gap-3">
          <button class="btn btn-navy d-inline-flex align-items-center gap-2 px-4 py-3 fw-semibold text-white rounded-3 shadow-sm" (click)="startVerification()">
            <i class="bi bi-arrow-right"></i> Start Verification 
          </button>
          <!-- <button class="btn btn-help btn-outline-secondary d-inline-flex align-items-center gap-2 px-4 py-2.5 fw-semibold rounded-3 bg-white" (click)="openHelp()">
            <i class="bi bi-question-circle"></i> Need Help?
          </button> -->
        </div>
      </footer>
  </div>
</div>